<template>
    <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">
            <slot>Lade...</slot>
        </span>
    </div>
</template>
